import { Button } from "@/components/ui/button";
import { ArrowDown, CalendarDays } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { nextBlackMountainDates, formatShort } from "@/data/blackMountainSchedule";
import { trackIntake } from "@/analytics";

const HERO_IMG = "/hero-office.jpg";

export default function Hero() {
  const [nextSaturday, setNextSaturday] = useState(() => nextBlackMountainDates(1)[0]);
  useEffect(() => setNextSaturday(nextBlackMountainDates(1)[0]), []);
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Warm natural clinic interior"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 lg:py-0">
        <div className="max-w-2xl">
          <p className="font-body text-xs tracking-[0.25em] uppercase text-[#E4DCCF] mb-6 animate-fade-in-up">
            Chiropractor Utilizing Extremity Adjusting &bull; Applied Kinesiology
          </p>
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-medium text-white leading-none tracking-tighter mb-8 animate-fade-in-up delay-100">
            Welcome Back <br />to Wellness
          </h1>
          <p className="font-body text-base sm:text-lg text-[#E4DCCF] leading-relaxed mb-10 max-w-lg animate-fade-in-up delay-200">
            Dr. Kevin Greenspan is back in practice after stepping away from full-time practice for several years — bringing decades of expertise in applied kinesiology and chiropractic care to Marion, NC. Tuesdays &amp; Thursdays, the care you deserve.
          </p>
          <Link
            to="/black-mountain"
            className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 backdrop-blur-md px-4 py-2 mb-8 font-body text-sm text-[#E4DCCF] hover:bg-white/20 hover:text-white transition-colors animate-fade-in-up delay-200"
            data-testid="hero-black-mountain-pill"
          >
            <CalendarDays size={14} className="text-[#C87B5D]" />
            <span>Next Black Mountain Saturday: <strong className="text-white" suppressHydrationWarning>{formatShort(nextSaturday)}</strong> · call to book</span>
          </Link>
          <div className="flex flex-wrap gap-4 animate-fade-in-up delay-300">
            <a href="#about">
              <Button
                data-testid="hero-learn-btn"
                className="rounded-full bg-[#C87B5D] hover:bg-[#b56a4e] text-white font-body text-sm px-8 h-12"
              >
                Learn More
              </Button>
            </a>
            <a href="/intake-form.docx" download="New-Patient-Intake-Form.docx" onClick={trackIntake}>
              <Button
                data-testid="hero-intake-btn"
                className="rounded-full bg-[#C87B5D] hover:bg-[#b56a4e] text-white font-body text-sm px-8 h-12"
              >
                Download Intake Form
              </Button>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-float">
        <a href="#about" className="text-white/60 hover:text-white transition-colors" data-testid="scroll-indicator">
          <ArrowDown size={20} />
        </a>
      </div>
    </section>
  );
}
